import { createSlice } from "@reduxjs/toolkit";

export const SetDisplayCollectionMyQueryOrDocumentSlice = createSlice({
  name: "SetDisplayCollectionMyQueryOrDocument",
  initialState: {
    myQuery: true,
    collection: false,
    document: false,
  },
  reducers: {
    displayMyQuery: (state) => {
      state.collection = false;
      state.document = false;
      state.myQuery = true;
    },
    displayCollection: (state) => {
      state.document = false;
      state.myQuery = false;
      state.collection = true;
    },
    displayDocument: (state) => {
      state.collection = false;
      state.myQuery = false;
      state.document = true;
    },
  },
});

export const { displayMyQuery, displayDocument, displayCollection } =
  SetDisplayCollectionMyQueryOrDocumentSlice.actions;

export default SetDisplayCollectionMyQueryOrDocumentSlice.reducer;
